import React from "react";
import Skeleton from "../skeleton";

const Mobile = () => (
	<>
		<div className="container">
			<div>
				<div className="title-container">
					<Skeleton
						width="138px"
						height="20px"
					/>
				</div>
				<div className="card-member">
					<div className="profile">
						<Skeleton
							width="40px"
							height="40px"
							borderRadius="50%"
						/>
						<div className="detail">
							<Skeleton
								width="88px"
								height="15px"
								borderRadius="8px"
							/>
							<Skeleton
								width="102px"
								height="15px"
								borderRadius="8px"
							/>
							<Skeleton
								width="117px"
								height="15px"
								borderRadius="8px"
							/>
						</div>
					</div>
					<Skeleton
						width="102px"
						height="34px"
						borderRadius="4px"
					/>
				</div>
			</div>
			<div className="pagination">
				{
					Array.from({ length: 5 }, (data, idx) => (
						<Skeleton
							key={idx}
							width="8px"
							height="8px"
							borderRadius="50%"
						/>
					))
				}
			</div>
			<Skeleton
				width="100%"
				height="20px"
			/>
		</div>
		<style jsx>
			{`
				.container {
					padding: 16px;
				}
				.card-member {
					display: flex;
					gap: 16px;
					justify-content: space-between;
          padding: 16px 8px 9px 8px;
					border: 1px solid #C4CDD5;
          border-radius: 8px;
				}
				.profile {
					display: flex;
					gap: 16px;
				}
        .detail {
          width: 130px;
        }
				.pagination {
					padding: 16px;
					display: flex;
					gap: 8px;
					align-content: center;
					justify-content: center;
				}
			`}
		</style>
	</>
);

export default Mobile;
